import { render, staticRenderFns } from "./OSgovAuth.vue?vue&type=template&id=74bccfc8"
import script from "./OSgovAuth.vue?vue&type=script&lang=js"
export * from "./OSgovAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports